module.exports = __webpack_public_path__ + "img/scene4-8.59f070c0.jpg";